import { Button } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useAppDispatch } from "app/store";
import { closeTrackingDialog } from "app/store/trackingApp/trackingDialogSlice";
import React from "react";

const ConfirmDialog: React.FC<{
  action?: any;
  title?: string;
  text?: string;
  customButton?: {
    action: any;
    title: string;
  };
}> = (props) => {
  const { action, title, text, customButton } = props;
  const dispatch = useAppDispatch();

  const handleClose = () => dispatch(closeTrackingDialog());

  const handleAction = () => {
    action();
    handleClose();
  };

  return (
    <>
      <DialogTitle id="tracking-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="tracking-dialog-description" className="whitespace-pre-line">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="flex justify-between w-full">
          <span>
          {
            customButton && (
              <Button color="primary" onClick={customButton.action}>
                {customButton.title}
              </Button>
              )
          }
          </span>
          <span>
            <Button color="primary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button onClick={handleAction} color="primary" autoFocus>
              Confirmar
            </Button>
          </span>
        </div>
      </DialogActions>
    </>
  );
};

export default ConfirmDialog;
